import DetailProductionScreen from "./DetailProductionScreen";
export default DetailProductionScreen;
